const ErrorBanner = () => {

    const bannerImageSrc = 'https://cdn.shopify.com/s/files/1/0621/7705/0873/files/image_49.png?v=1666600429'
    const mobileBannerImageSrc = 'https://cdn.shopify.com/s/files/1/0621/7705/0873/files/image_49_ba33fddd-92d6-4a18-a79f-b02c31f90cac.jpg?v=1666608132'
    
    return (
        <div className="w-full md:h-[500px] h-[720px] relative flex justify-center items-center flex-col">
            <img src={bannerImageSrc} className="w-full object-cover h-full absolute top-0 md:block hidden"/>
            <img src={mobileBannerImageSrc} className="w-full object-cover h-full absolute top-0 md:hidden block"/>
            <div className="md:w-[85%] w-full flex justify-start items-start flex-col text-white h-full px-4 md:py-24 py-52 absolute"> 
                <h1 className="w-full font-bold text-[40px] leading-[40px] tracking-[-1px]">ERROR 404</h1>
                <h2 className="md:w-full w-[70%] text-lg leading-[24px]">THE PAGE YOU ARE LOOKING FOR IS NOT AVAILABLE</h2>
            </div>
        </div>
    )
}

export default ErrorBanner